import Checkbox from "components/common/Fields/Checkbox";
import ReactStrapTable from "components/reactStrapTable";
import SearchButtons from "components/SearchButtons";
import { Formik } from "formik";
import React, { useState } from "react";
import columnSelectorIcon from "../../../../../assets/icon/column-selector.svg";
import editIocn from "../../../../../assets/inventory/edit-icon.svg";
import deleteIcon from "../../../../../assets/inventory/delete-icon.svg";
import CloseIcon from "../../../../../assets/icon/chatClose.svg";
import exports from "assets/icon/export-icon.svg";
import refreshIcon from "../../../../../assets/icon/refresh-purple.svg";
import reloadIcon from "assets/icon/reload-icon.svg";

import {
  Button,
  ButtonGroup,
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  Input,
  Offcanvas,
  OffcanvasBody,
  Row,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
// import DragDrop from "components/DragDrop";
// import Drawer from "components/Drawer";
// import OrderEditDetails from "../OrderEditDetails";
const rowData = [
  {
    id: 23,
    status: "Shipped",
    orderDate: "01/10/2025",
    shippedDate: "1023850",
    orderId: "01/09/2025",
    wholeSalerName: "Mckesson",
    totalItem: "12",
    exception: "Limited DC availablity",
  },
  {
    id: 24,
    status: "Shipped",
    orderDate: "01/10/2025",
    shippedDate: "1023850",
    orderId: "01/09/2025",
    wholeSalerName: "Ando",
    totalItem: "12",
    exception: "-",
  },
  {
    id: 25,
    status: "Shipped",
    orderDate: "01/10/2025",
    shippedDate: "1023850",
    orderId: "01/09/2025",
    wholeSalerName: "Cardinal",
    totalItem: "1",
    exception: "-",
  },
];

const ReceiveOrderQueue = () => {
  const navigate = useNavigate();
  const [refreshBtn, setRefreshBtn] = useState(false);
  const [data, setData] = useState();
  const [rSelected, setRSelected] = useState("off");
  const [tableData, setTableData] = useState(rowData);
  // const [data, setData] = useState([]);

  function handleClick() {
    // window.location.reload();
  }

  const handleRowClick = (row) => {
    navigate(`/inventory-purchase-order/order-receive-details/${row.id}`, {
      state: row,
    });
  };

  const handleRefresh = () => {
    setRefreshBtn(true);
    setTimeout(() => {
      setRefreshBtn(false);
    }, 1000);
  };

  const columnData = [
    {
      id: "1",
      dataField: "status",
      text: "Status",
      show: true,
      width: 100,
      sort: true,
    },
    {
      id: "2",
      dataField: "orderDate",
      text: "Order Date",
      show: true,
      width: 125,
      sort: true,
    },
    {
      id: "3",
      dataField: "shippedDate",
      text: "Shipped Date",
      show: true,
      width: 150,
      sort: true,
    },
    {
      id: "4",
      dataField: "orderId",
      text: "Order ID",
      show: true,
      width: 160,
      sort: true,
    },
    {
      id: "5",
      dataField: "wholeSalerName",
      text: "Wholesaler Name",
      show: true,
      width: 180,
      sort: true,
      //   cellRenderer: (rowData) => (
      //     <a href="/on-order-queue-details" style={{ color: "#212529" }}>
      //       {rowData.mfgValue}
      //     </a>
      //   ),
      // cellRenderer: (rowData) => (
      //   <a href="/order-receive-details" style={{ color: "purple" }}>
      //     {rowData.wholeSalerName}
      //   </a>
      // ),
    },
    {
      id: "6",
      dataField: "totalItem",
      text: "Total Items",
      show: true,
      width: 150,
      sort: true,
      //   cellRenderer: (rowData) => {
      //     const drugName = rowData.tot;
      //     const displayText =
      //       drugName.length > 20 ? `${drugName.substring(0, 15)}...` : drugName;
      //     return (
      //       <span style={{ cursor: "pointer" }} title={drugName}>
      //         {displayText}
      //       </span>
      //     );
      //   },
    },
    {
      id: "8",
      dataField: "exception",
      text: "Exceptions",
      show: true,
      width: 140,
      sort: true,
    },
  ];

  function handleClick() {
    // window.location.reload();
    setData([...rowData]);
  }
  const toggleFilter = () => {
    setRSelected((prev) => (prev === "off" ? "on" : "off"));
  };

  // const tableFilterData = tableData.length
  //   ? tableData.map((patient) => {
  //       return {

  //         id: patient.id,
  //         status: patient.status,
  //     orderDate: patient.orderDate,
  //     shippedDate: patient.shippedDate,
  //     orderId: patient.orderId,
  //     wholeSalerName:patient.wholeSalerName,
  //     totalItem: patient.totalItem,
  //     exception: patient.exception,
  //         //medication: user.username,
  //       };
  //     })
  //   : [
  //       {
  //         id: "",
  //         status: "",
  //     orderDate: "",
  //     shippedDate: "",
  //     orderId: "",
  //     wholeSalerName:"",
  //     totalItem: "",
  //     exception: "",
  //       },

  //     ];

  return (
    <div className="table-card scroll-table position-relative border-0 pt-1 rounded bg-white">
      {refreshBtn && (
        <div className="refresh-bgv">
          <img className="rotate-img" src={refreshIcon} width={40} />
        </div>
      )}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
          <div>
            <SearchButtons
              InSize={200}
              placeHolder={"Search by Drug Name"}
              data={rowData}
              setFilterData={setTableData}
            />
          </div>
          <div>
            <Dropdown isOpen={undefined} toggle={undefined}>
              <DropdownToggle className="clmn">
                <img src={columnSelectorIcon} alt="not available" />
                <span className="">
                  Columns{" "}
                  {/* {totalCount > 0 && (
                                    <div className="totalcount">{totalCount}</div>
                                  )} */}
                </span>
              </DropdownToggle>
            </Dropdown>
          </div>
          <div className="d-flex justify-content-center align-items-center gap-2">
            <span className="f-16 font-weight-600">Filter</span>
            <ButtonGroup className="filter-btn-group">
              <Button
                color="info"
                outline
                onClick={toggleFilter}
                active={rSelected === "off"}
              >
                OFF
              </Button>
              <Button
                color="info"
                outline
                active={rSelected === "on"}
                onClick={toggleFilter}
              >
                ON
              </Button>
            </ButtonGroup>
          </div>
        </div>
        <div className="d-flex">
          <Button color="primary" onClick={handleRefresh}>
            <img src={reloadIcon} alt="Refreshing..." />
            Refresh
          </Button>
        </div>
      </div>
      <div fixed-height={rowData.length > 0 ? "fixed-height" : "default"}>
        <ReactStrapTable
          id="purchase-receive-orders"
          columns={columnData}
          data={rowData}
          enablerowRouting={true}
          handleRowClick={handleRowClick}
          redRow={[0]}
        />
      </div>
      <div></div>
    </div>
  );
};

export default ReceiveOrderQueue;
